import { render, staticRenderFns } from "./projectManage.vue?vue&type=template&id=50585f27&scoped=true"
import script from "./projectManage.vue?vue&type=script&lang=js"
export * from "./projectManage.vue?vue&type=script&lang=js"
import style0 from "./projectManage.vue?vue&type=style&index=0&id=50585f27&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50585f27",
  null
  
)

export default component.exports